const fields = [
  {
    key: 'fenceName',
    label: 'report.fields.locationName',
    header: 'fenceName',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'transitOn',
    label: 'report.fields.timeInGeo',
    header: 'timeInGeo',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'doorOpen',
    label: 'report.fields.doorOpen',
    header: 'timeDoorOpen',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'doorClose',
    label: 'report.fields.doorClose',
    header: 'timeDoorClose',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'transitOnOut',
    label: 'report.fields.timeOutGeo',
    header: 'timeOutGeo',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'timeInQueue',
    label: 'report.fields.timeInQueue',
    header: 'timeInQueue',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'timeLoading',
    label: 'report.fields.timeLoading',
    header: 'timeLoading',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'timeOutQueue',
    label: 'report.fields.timeOutQueue',
    header: 'timeOutQueue',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'timeInGeofence',
    label: 'report.fields.durationInGeo',
    header: 'timeInsideGeo',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'timeBetweenGeofence',
    label: 'report.fields.durationBetweenGeo',
    header: 'timeBetweenGeo',
    filter: false,
    width: 20,
    disabled: true,
  },
]
export default fields
